import moment, { Moment } from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { QueryParamConfig, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { getiTrustRequests } from '~/javascripts/admin/actions/itrust-requests';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { toQueryParams } from '~/javascripts/admin/utils';
import Headings from '../../atoms/Headings';
import BreadCrumb from '../../molecules/BreadCrumb';
import FilterForm from './FilterForm';
import ListTable from './ListTable';

type iTrustRequests = Awaited<ReturnType<typeof getiTrustRequests>>;

const PageWrapper = styled.div``;

const HeadingWrapper = styled.div`
  display: flex;
  margin: 20px 0 10px 0;
  gap: 12px;
`;

const SearchResult = styled.span`
  display: inline-block;
  margin-left: 1rem;
`;

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '取引管理', href: '', isCurrentPage: true },
  { value: 'マイナンバー認証履歴', href: '', isCurrentPage: true },
];

const MomentParam: QueryParamConfig<Moment | null | undefined> = {
  encode: (value) => (value ? value.toISOString() : null),
  decode: (value) => (value && typeof value === 'string' ? moment(value) : null),
};

const queryParamConfigs = {
  from: withDefault(MomentParam, null),
  to: withDefault(MomentParam, null),
  organizationCode: withDefault(StringParam, null),
};

const MyNumberAuthRequests = () => {
  const user = useAppSelector((state) => state.user);
  const [iTrustRequests, setiTrustRequests] = useState<iTrustRequests>();

  const [query, setQuery] = useQueryParams({
    ...queryParamConfigs,
  });

  const fetchiTrustRequests = useCallback(
    (page = 1) => {
      const { organizationCode, ...restQuery } = query;
      const effectiveQuery = !user.isServiceUser() ? restQuery : query;
      const queryString = toQueryParams({
        ...effectiveQuery,
        page,
        billable: true,
      });

      getiTrustRequests(queryString).then((res) => setiTrustRequests(res));
    },
    [query]
  );

  const onChangePage = (page: number) => {
    fetchiTrustRequests(page);
  };

  useEffect(() => {
    fetchiTrustRequests();
  }, [query, fetchiTrustRequests]);

  return (
    <PageWrapper>
      <BreadCrumb crumbs={CRUMBS} />
      <FilterForm query={query} setQuery={setQuery} />
      <HeadingWrapper>
        <Headings.h5>検索結果</Headings.h5>
        {(iTrustRequests?.count ?? 0) > 0 && (
          <SearchResult>件数：{iTrustRequests?.count}</SearchResult>
        )}
      </HeadingWrapper>
      <ListTable iTrustRequests={iTrustRequests} onChangePage={onChangePage} />
    </PageWrapper>
  );
};

export default MyNumberAuthRequests;
